module.exports = __webpack_public_path__ + "static/media/mail_icon.392608bf.svg";